<nz-form-control [formGroup]="formGroup">
    <label nz-checkbox [hidden]="hideTitle" [formControlName]="formFieldInfo.fieldCode" [(ngModel)]="defaultValue" [attr.data-value]="defaultValue"
        (ngModelChange)="modelChange()">
        <input (ngModelChange)="modelChange()" hidden [(ngModel)]="defaultValue" [attr.data-value]="defaultValue" [formControlName]="formFieldInfo.fieldCode"/>
        <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    </label>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-control>